import { ProductTypeUid } from './product-type-uid.enum';

export const ApparelProductTypeUids = [
  ProductTypeUid.HOODIE,
  ProductTypeUid.ONESIE,
  ProductTypeUid.SWEATSHIRT,
  ProductTypeUid.T_SHIRT,
  ProductTypeUid.TANK_TOP,
  ProductTypeUid.JACKETS_AND_VESTS,
  ProductTypeUid.POLOS,
  ProductTypeUid.HATS,
  ProductTypeUid.ACCESSORIES,
  ProductTypeUid.HOME_AND_LIVING,
];

export const BagProductTypeUids = [ProductTypeUid.TOTE_BAG, ProductTypeUid.BACKPACKS];

export const ApparelAndAccessoriesProductTypeUids = [...ApparelProductTypeUids, ...BagProductTypeUids];

export const CardProductTypeUids = [ProductTypeUid.CARDS, ProductTypeUid.PACK_OF_CARDS];
